/* Bedz King Product runtime — Native Product behavior plus interaction-loaded YouTube, Fera reviews, */
(function () {
  'use strict';

  function initGallery() {
    var gallery = document.querySelector('[data-bedz-product-gallery]');

    if (!gallery) {
      return;
    }

    var wrapper = gallery.querySelector('.swiper-wrapper');
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-slide')
    );
    var previous = gallery.querySelector('[data-bedz-gallery-prev]');
    var next = gallery.querySelector('[data-bedz-gallery-next]');
    var pagination = gallery.querySelector('[data-bedz-gallery-pagination]');
    var mobile = window.matchMedia('(max-width: 767px)');
    var activeIndex = 0;
    var frame = 0;

    if (!wrapper || !slides.length) {
      return;
    }

    function setActive(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      activeIndex = index;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('swiper-slide-active', slideIndex === index);
      });

      if (pagination) {
        var bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        Array.prototype.forEach.call(bullets, function (bullet, bulletIndex) {
          bullet.classList.toggle(
            'swiper-pagination-bullet-active',
            bulletIndex === index
          );
        });
      }
    }

    function goTo(index, behavior) {
      if (!mobile.matches) {
        return;
      }

      index = Math.max(0, Math.min(slides.length - 1, index));
      wrapper.scrollTo({
        left: index * wrapper.clientWidth,
        behavior: behavior || 'smooth'
      });
      setActive(index);
    }

    function updateFromScroll() {
      frame = 0;

      if (!mobile.matches || !wrapper.clientWidth) {
        return;
      }

      setActive(Math.round(wrapper.scrollLeft / wrapper.clientWidth));
    }

    if (pagination) {
      pagination.textContent = '';

      slides.forEach(function (_, index) {
        var bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-hidden', 'true');
        pagination.appendChild(bullet);
      });
    }

    if (slides.length <= 1) {
      if (previous) previous.hidden = true;
      if (next) next.hidden = true;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    wrapper.addEventListener(
      'scroll',
      function () {
        if (!frame) {
          frame = window.requestAnimationFrame(updateFromScroll);
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        if (mobile.matches) {
          goTo(activeIndex, 'auto');
        }
      },
      { passive: true }
    );

    setActive(0);

    window.BedzProductGallery = {
      getIndex: function () {
        return activeIndex;
      },
      goTo: function (index) {
        goTo(index, 'auto');
      }
    };
  }

  function updateDesktopHero(thumbnail) {
    if (!thumbnail || !window.matchMedia('(min-width: 768px)').matches) {
      return;
    }

    var imageUrl = thumbnail.getAttribute('data-image-url');
    var hero = document.getElementById('ProductPhotoImg');

    if (!imageUrl || !hero) {
      return;
    }

    hero.removeAttribute('srcset');
    hero.setAttribute('src', imageUrl);

    var thumbnailImage = thumbnail.querySelector('img');
    var altText =
      (thumbnailImage && thumbnailImage.getAttribute('alt')) ||
      thumbnail.getAttribute('title') ||
      '';

    if (altText) {
      hero.setAttribute('alt', altText);
      hero.setAttribute('title', altText);
    }
  }

  var desktopImageOverlayMedia = window.matchMedia('(min-width: 1200px)');
  var desktopImageOverlay = null;
  var desktopImageOverlayOpener = null;

  function getDesktopLargeImageUrl(thumbnail) {
    var imageUrl = thumbnail
      ? thumbnail.getAttribute('data-image-url')
      : '';

    if (!imageUrl) {
      return '';
    }

    try {
      var largeUrl = new URL(imageUrl, window.location.href);
      largeUrl.searchParams.set('width', '1800');
      largeUrl.searchParams.delete('height');
      largeUrl.searchParams.delete('crop');
      return largeUrl.toString();
    } catch (error) {
      return imageUrl;
    }
  }

  function closeDesktopImageOverlay() {
    if (desktopImageOverlay && desktopImageOverlay.open) {
      desktopImageOverlay.close();
    }
  }

  function ensureDesktopImageOverlay() {
    if (desktopImageOverlay) {
      return desktopImageOverlay;
    }

    if (
      !window.HTMLDialogElement ||
      typeof HTMLDialogElement.prototype.showModal !== 'function'
    ) {
      return null;
    }

    var dialog = document.createElement('dialog');
    var stage = document.createElement('div');
    var image = document.createElement('img');
    var closeButton = document.createElement('button');

    dialog.className = 'bedz-desktop-image-overlay';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    stage.className = 'bedz-desktop-image-overlay__stage';
    image.className = 'bedz-desktop-image-overlay__image';
    image.setAttribute('draggable', 'false');
    closeButton.type = 'button';
    closeButton.className = 'bedz-desktop-image-overlay__close';
    closeButton.setAttribute('aria-label', 'Close enlarged image');
    closeButton.textContent = '×';

    stage.appendChild(image);
    dialog.appendChild(stage);
    dialog.appendChild(closeButton);
    document.body.appendChild(dialog);

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeDesktopImageOverlay();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('bedz-desktop-image-overlay-open');

      if (desktopImageOverlayOpener && desktopImageOverlayOpener.isConnected) {
        desktopImageOverlayOpener.focus({ preventScroll: true });
      }

      desktopImageOverlayOpener = null;
    });

    desktopImageOverlay = dialog;
    return dialog;
  }

  function openDesktopImageOverlay(thumbnail) {
    if (!desktopImageOverlayMedia.matches || !thumbnail) {
      return;
    }

    var dialog = ensureDesktopImageOverlay();

    if (!dialog) {
      return;
    }

    var image = dialog.querySelector('.bedz-desktop-image-overlay__image');
    var thumbnailImage = thumbnail.querySelector('img');
    var imageUrl = getDesktopLargeImageUrl(thumbnail);
    var altText =
      (thumbnailImage && thumbnailImage.getAttribute('alt')) ||
      thumbnail.getAttribute('title') ||
      'Product image';

    if (!image || !imageUrl) {
      return;
    }

    image.setAttribute('src', imageUrl);
    image.setAttribute('alt', altText);
    desktopImageOverlayOpener = thumbnail;
    document.body.classList.add('bedz-desktop-image-overlay-open');

    if (!dialog.open) {
      try {
        dialog.showModal();
      } catch (error) {
        document.body.classList.remove('bedz-desktop-image-overlay-open');
        desktopImageOverlayOpener = null;
      }
    }
  }

  function initDesktopImageOverlay() {
    function mediaChanged() {
      if (!desktopImageOverlayMedia.matches) {
        closeDesktopImageOverlay();
      }
    }

    if (desktopImageOverlayMedia.addEventListener) {
      desktopImageOverlayMedia.addEventListener('change', mediaChanged);
    } else {
      desktopImageOverlayMedia.addListener(mediaChanged);
    }
  }

  function initDesktopThumbnails() {
    var thumbs = document.querySelectorAll(
      '#ProductThumbs .product-single__thumbnail'
    );

    Array.prototype.forEach.call(thumbs, function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        if (!window.matchMedia('(min-width: 768px)').matches) {
          return;
        }

        event.preventDefault();
        updateDesktopHero(thumbnail);

        if (desktopImageOverlayMedia.matches) {
          openDesktopImageOverlay(thumbnail);
        }
      });

      thumbnail.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 992px)').matches) {
          updateDesktopHero(thumbnail);
        }
      });
    });
  }

  function initVariantSelectors() {
    var picker = document.querySelector('[data-bedz-variant-picker]');

    if (!picker) {
      return;
    }

    var variantInput = picker.querySelector('[data-bedz-variant-id]');
    var dataTemplate = picker.querySelector('template[data-bedz-variant-data]');

    if (!variantInput || !dataTemplate) {
      return;
    }

    var selectors = Array.prototype.slice.call(
      picker.querySelectorAll('[data-bedz-option-position]')
    );
    var variants = Array.prototype.slice.call(
      dataTemplate.content.querySelectorAll('[data-bedz-variant-record]')
    );
    var addButton = document.getElementById('AddToCart');
    var addButtonText = document.getElementById('AddToCartText');
    var stockWrapper = document.getElementById('hidden-stock-wrapper');
    var stockMessage = stockWrapper
      ? stockWrapper.querySelector('.product-unavailable-msg')
      : null;
    var modelNumber = document.querySelector('[data-bedz-model-number]');
    var marketingBanner = document.querySelector('[data-bedz-marketing-banner]');
    var defaultLabel = addButton
      ? addButton.getAttribute('data-bedz-default-label') || 'Add to Cart'
      : 'Add to Cart';

    var preorderLabel = addButton
      ? addButton.getAttribute('data-bedz-preorder-label') || 'Pre-Order Now'
      : 'Pre-Order Now';

    function selectedValues() {
      var values = [];

      selectors.forEach(function (selector) {
        var position = Number(
          selector.getAttribute('data-bedz-option-position')
        );

        values[position - 1] = selector.value;
      });

      return values;
    }

    function recordOption(record, position) {
      return record.getAttribute('data-option' + position) || '';
    }

    function recordMatches(record, values, overridePosition, overrideValue) {
      return values.every(function (value, index) {
        var position = index + 1;
        var expected =
          position === overridePosition ? overrideValue : value;

        if (!expected) {
          return true;
        }

        return recordOption(record, position) === expected;
      });
    }

    function refreshOptionAvailability(values, preservedPosition) {
      selectors.forEach(function (selector) {
        var position = Number(
          selector.getAttribute('data-bedz-option-position')
        );

        Array.prototype.forEach.call(selector.options, function (option) {
          var possible = variants.some(function (record) {
            return recordMatches(
              record,
              values,
              position,
              option.value
            );
          });

          option.disabled = !possible;
        });

        if (position === preservedPosition) {
          return;
        }

        var selectedOption = selector.options[selector.selectedIndex];

        if (selectedOption && selectedOption.disabled) {
          var replacement = Array.prototype.find.call(
            selector.options,
            function (option) {
              return !option.disabled;
            }
          );

          if (replacement) {
            selector.value = replacement.value;
          }
        }
      });
    }

    function normalizeSelection(preservedPosition) {
      var values = selectedValues();

      refreshOptionAvailability(values, preservedPosition);
      values = selectedValues();
      refreshOptionAvailability(values, null);

      return values;
    }

    function findVariant(values) {
      return variants.find(function (record) {
        return values.every(function (value, index) {
          return recordOption(record, index + 1) === value;
        });
      }) || null;
    }

    function updatePrice(record) {
      var price = record
        ? record.getAttribute('data-price-display') || ''
        : '';
      var compare = record
        ? record.getAttribute('data-compare-display') || ''
        : '';
      var savings = record
        ? record.getAttribute('data-savings-display') || ''
        : '';
      var variantId = record
        ? record.getAttribute('data-variant-id') || ''
        : '';

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-bedz-current-price]'),
        function (node) {
          node.textContent = price;
        }
      );

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-bedz-compare-price]'),
        function (node) {
          node.textContent = compare;
          node.hidden = !compare;
        }
      );

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-bedz-savings]'),
        function (node) {
          node.hidden = !savings;
          node.setAttribute('data-variant-id', variantId);
        }
      );

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-bedz-savings-amount]'),
        function (node) {
          node.textContent = savings;
        }
      );

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-bedz-price]'),
        function (node) {
          node.setAttribute('data-variant-id', variantId);
        }
      );
    }

    function updateModelNumber(record) {
      if (!modelNumber || !record) {
        return;
      }

      var sku = record.getAttribute('data-sku') || '';
      var barcode = record.getAttribute('data-barcode') || '';
      var text = 'Model: ' + sku;

      if (barcode) {
        text += ' : UPC ' + barcode;
      }

      modelNumber.textContent = text;
    }

    function formatRestockDate(value) {
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');

      if (!match) {
        return '';
      }

      var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      var monthIndex = parseInt(match[2], 10) - 1;
      var day = parseInt(match[3], 10);

      if (monthIndex < 0 || monthIndex > 11 || !day) {
        return '';
      }

      var mod100 = day % 100;
      var suffix = 'th';

      if (mod100 < 11 || mod100 > 13) {
        switch (day % 10) {
          case 1:
            suffix = 'st';
            break;
          case 2:
            suffix = 'nd';
            break;
          case 3:
            suffix = 'rd';
            break;
        }
      }

      return monthNames[monthIndex] + ' ' + day + suffix;
    }

    function formatPreorderDate(value) {
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');

      if (!match) {
        return '';
      }

      var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      var monthIndex = parseInt(match[2], 10) - 1;
      var day = parseInt(match[3], 10);
      var year = parseInt(match[1], 10);

      if (monthIndex < 0 || monthIndex > 11 || !day || !year) {
        return '';
      }

      return monthNames[monthIndex] + ' ' + day + ', ' + year;
    }

    function updatePreorderMarketing(record) {
      if (!marketingBanner || !record) {
        return;
      }

      var customMessage =
        marketingBanner.getAttribute('data-bedz-custom-marketing-text') || '';

      if (customMessage) {
        marketingBanner.textContent = customMessage;
        marketingBanner.hidden = false;
        return;
      }

      var preorderEnabled =
        record.getAttribute('data-preorder-enabled') === 'true';
      var shipDate = formatPreorderDate(
        record.getAttribute('data-expected-ship-date') || ''
      );
      var arrivalDate = formatPreorderDate(
        record.getAttribute('data-expected-arrival-date') || ''
      );
      var message = '';

      if (preorderEnabled && shipDate) {
        message = (
          marketingBanner.getAttribute('data-bedz-expected-ship-template') || ''
        ).replace('__DATE__', shipDate);
      } else if (preorderEnabled && arrivalDate) {
        message = (
          marketingBanner.getAttribute('data-bedz-expected-arrival-template') || ''
        ).replace('__DATE__', arrivalDate);
      }

      marketingBanner.textContent = message;
      marketingBanner.hidden = !message;
    }

    function showAvailability(message) {
      if (!stockWrapper || !stockMessage) {
        return;
      }

      if (message) {
        stockMessage.textContent = message;
        stockWrapper.classList.remove('hide');
      } else {
        stockWrapper.classList.add('hide');
      }
    }

    function findNodeByImageId(nodes, imageId) {
      return Array.prototype.find.call(nodes, function (node) {
        return String(node.getAttribute('data-image-id') || '') ===
          String(imageId || '');
      }) || null;
    }

    function syncGallery(record) {
      if (!record) {
        return;
      }

      var imageId = record.getAttribute('data-image-id');

      if (!imageId) {
        return;
      }

      var thumbnails = document.querySelectorAll(
        '#ProductThumbs .product-single__thumbnail[data-image-id]'
      );
      var thumbnail = findNodeByImageId(thumbnails, imageId);

      if (thumbnail) {
        updateDesktopHero(thumbnail);
      }

      var slides = document.querySelectorAll(
        '[data-bedz-product-gallery] .swiper-slide[data-image-id]'
      );
      var slide = findNodeByImageId(slides, imageId);

      if (
        slide &&
        window.BedzProductGallery &&
        typeof window.BedzProductGallery.goTo === 'function'
      ) {
        var slideIndex = Array.prototype.indexOf.call(slides, slide);

        if (slideIndex >= 0) {
          window.BedzProductGallery.goTo(slideIndex);
        }
      }
    }

    function updateUrl(variantId) {
      if (!variantId || !window.history || !window.history.replaceState) {
        return;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function applySelection(preservedPosition) {
      var values = normalizeSelection(preservedPosition);
      var record = findVariant(values);

      if (!record) {
        variantInput.value = '';

        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
          addButton.classList.remove('add-to-cart-btn--preorder');
        }

        if (addButtonText) {
          addButtonText.textContent = 'Unavailable';
        }

        showAvailability('This option combination is unavailable.');
        return;
      }

      var variantId = record.getAttribute('data-variant-id') || '';
      var available = record.getAttribute('data-available') === 'true';
      var restockDate =
        record.getAttribute('data-restock-date') || '';
      var restockDisplay = formatRestockDate(restockDate);

      variantInput.value = variantId;
      updatePrice(record);
      updateModelNumber(record);
      updatePreorderMarketing(record);

      if (addButton) {
        addButton.disabled = !available;
        addButton.setAttribute(
          'aria-disabled',
          available ? 'false' : 'true'
        );
        addButton.classList.toggle(
          'add-to-cart-btn--preorder',
          available && record.getAttribute('data-preorder-enabled') === 'true'
        );
      }

      if (addButtonText) {
        addButtonText.textContent = available
          ? (record.getAttribute('data-preorder-enabled') === 'true' ? preorderLabel : defaultLabel)
          : 'Sold Out';
      }

      if (available) {
        showAvailability('');
      } else {
        showAvailability(
          restockDisplay
            ? 'This item will be back in-stock ' + restockDisplay
            : 'This option is currently unavailable.'
        );
      }

      syncGallery(record);
      updateUrl(variantId);
    }

    function findVariantForImageId(imageId) {
      var matches = variants.filter(function (record) {
        return String(record.getAttribute('data-image-id') || '') ===
          String(imageId || '');
      });

      if (!matches.length) {
        return null;
      }

      if (matches.length === 1) {
        return matches[0];
      }

      var values = selectedValues();
      var bestRecord = matches[0];
      var bestScore = -1;

      matches.forEach(function (record) {
        var score = 0;

        values.forEach(function (value, index) {
          if (value && recordOption(record, index + 1) === value) {
            score += 1;
          }
        });

        if (score > bestScore) {
          bestScore = score;
          bestRecord = record;
        }
      });

      return bestRecord;
    }

    function selectVariantRecord(record) {
      if (!record) {
        return;
      }

      selectors.forEach(function (selector) {
        var position = Number(
          selector.getAttribute('data-bedz-option-position')
        );
        var value = recordOption(record, position);

        if (value) {
          selector.value = value;
        }
      });

      applySelection(null);
    }

    selectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        applySelection(
          Number(selector.getAttribute('data-bedz-option-position'))
        );
      });
    });

    Array.prototype.forEach.call(
      document.querySelectorAll(
        '#ProductThumbs .product-single__thumbnail[data-image-id]'
      ),
      function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          if (!window.matchMedia('(min-width: 768px)').matches) {
            return;
          }

          var record = findVariantForImageId(
            thumbnail.getAttribute('data-image-id')
          );

          selectVariantRecord(record);
        });
      }
    );

    applySelection(null);
  }

  function initMattressLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('._mattress-module .pixie[data-url]');

      if (!link || event.target.closest('.add-btn, .bedz-qty-control, input')) {
        return;
      }

      var url = link.getAttribute('data-url');

      if (url) {
        window.location.assign(url);
      }
    });

    document.addEventListener('keydown', function (event) {
      var link = event.target.closest('._mattress-module .pixie[data-url]');

      if (!link || (event.key !== 'Enter' && event.key !== ' ')) {
        return;
      }

      event.preventDefault();

      var url = link.getAttribute('data-url');

      if (url) {
        window.location.assign(url);
      }
    });
  }

  function initQuantityControls() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.bedz-qty-minus, .bedz-qty-plus');

      if (!button || !document.body.classList.contains('template-product')) {
        return;
      }

      event.preventDefault();

      var table = button.closest('.table');
      var input = table ? table.querySelector('input') : null;

      if (!input) {
        return;
      }

      var quantity = parseInt(input.value, 10) || 1;

      if (button.classList.contains('bedz-qty-minus')) {
        quantity = Math.max(1, quantity - 1);
      } else {
        quantity += 1;
      }

      input.value = String(quantity);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initMattressAddToCart() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('._mattress-module .add-btn.add-one');

      if (!button) {
        return;
      }

      event.preventDefault();

      if (button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      var item = button.closest('._mattress-item');
      var variantId = item ? item.getAttribute('data-variant-id') : '';
      var table = button.closest('.table');
      var quantityInput = table ? table.querySelector('input') : null;
      var quantity = quantityInput
        ? parseInt(quantityInput.value, 10) || 1
        : 1;

      if (!variantId) {
        return;
      }

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-submitting');

      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';

      [
        ['id', variantId],
        ['quantity', String(quantity)],
        ['return_to', '/cart']
      ].forEach(function (field) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = field[0];
        input.value = field[1];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      HTMLFormElement.prototype.submit.call(form);
    });
  }

  function initTabs() {
    document.addEventListener('click', function (event) {
      var mobileTab = event.target.closest('.mobile-tab');

      if (mobileTab) {
        event.preventDefault();

        var content = mobileTab.nextElementSibling;

        if (content) {
          content.classList.toggle('hide');
        }

        mobileTab.classList.toggle('active');

        window.setTimeout(function () {
          mobileTab.scrollIntoView({
            behavior: 'auto',
            block: 'start'
          });
        }, 100);

        return;
      }

      var tab = event.target.closest('.tabs a, .tab-link');

      if (!tab) {
        return;
      }

      var target = tab.getAttribute('href');

      if (!target || target.charAt(0) !== '#') {
        return;
      }

      var panel = document.querySelector(target);

      if (!panel) {
        return;
      }

      event.preventDefault();

      Array.prototype.forEach.call(
        document.querySelectorAll('.tabs a, .tab-link'),
        function (item) {
          item.classList.remove('_active', 'active');
        }
      );

      tab.classList.add('_active', 'active');

      Array.prototype.forEach.call(
        document.querySelectorAll('.tab-content, .tab-pane'),
        function (item) {
          item.classList.add('hide');
          item.classList.remove('active');
        }
      );

      panel.classList.remove('hide');
      panel.classList.add('active');
    });
  }

  function initMobileImageViewer() {
    var mobile = window.matchMedia('(max-width: 767px)');

    if (
      !window.HTMLDialogElement ||
      typeof HTMLDialogElement.prototype.showModal !== 'function'
    ) {
      return;
    }

    var root = document.querySelector(
      '.product-single__hero .bedz-product-media'
    );
    var gallery = root ? root.querySelector('.swiper-container') : null;

    if (!root || !gallery) {
      return;
    }

    var scriptNode = document.querySelector(
      'script[src*="bedz-product.js"]'
    );
    var viewerAsset = scriptNode
      ? scriptNode.src.replace(
          /bedz-product\.js(?=\?|$)/,
          'bedz-product-image-viewer.js'
        )
      : '';

    if (!viewerAsset) {
      return;
    }

    var button = document.createElement('button');
    var badge = document.createElement('span');
    var pending = null;
    var loading = false;
    var touch = null;
    var last = null;
    var lastTouch = 0;

    root.classList.add('bbk-mi-v2-root');
    button.type = 'button';
    button.id = 'BbkMobileImageEnlargeV2';
    button.className = 'bbk-mi-v2-open';
    button.setAttribute('aria-label', 'Enlarge current product image');
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', 'BbkMobileImageDialogV2');
    badge.textContent = 'Enlarge';
    button.appendChild(badge);
    root.appendChild(button);

    function activeImage() {
      return (
        gallery.querySelector(
          '.swiper-slide-active img.bedz-product-gallery__image'
        ) ||
        gallery.querySelector('img.bedz-product-gallery__image')
      );
    }

    function picture(node) {
      if (!node || !node.closest || !gallery.contains(node)) {
        return null;
      }

      var slide = node.closest('.swiper-slide');

      return slide
        ? slide.querySelector('img.bedz-product-gallery__image')
        : null;
    }

    function imageKey(image) {
      return (
        image.currentSrc ||
        image.getAttribute('src') ||
        ''
      )
        .split('?')[0]
        .split('/')
        .pop();
    }

    function resetGesture() {
      touch = null;
      last = null;
    }

    function invokeViewer(image) {
      if (!window.BbkMobileImageViewerV2 || !image) {
        return;
      }

      window.BbkMobileImageViewerV2.open(
        gallery,
        image,
        button
      );
    }

    function ready() {
      loading = false;
      button.removeAttribute('aria-busy');
      badge.textContent = 'Enlarge';

      if (
        pending &&
        mobile.matches &&
        window.BbkMobileImageViewerV2
      ) {
        invokeViewer(pending);
      }

      pending = null;
    }

    function failed(script) {
      loading = false;
      pending = null;
      button.removeAttribute('aria-busy');
      badge.textContent = 'Retry enlarge';

      if (script && script.parentNode) {
        script.remove();
      }
    }

    function open(image) {
      image = picture(image);

      if (!mobile.matches || !image) {
        return;
      }

      resetGesture();
      pending = image;

      if (window.BbkMobileImageViewerV2) {
        ready();
        return;
      }

      if (loading) {
        return;
      }

      loading = true;
      button.setAttribute('aria-busy', 'true');
      badge.textContent = 'Opening...';

      var script = document.createElement('script');
      script.src = viewerAsset;
      script.async = true;
      script.onload = function () {
        if (window.BbkMobileImageViewerV2) {
          ready();
        } else {
          failed(script);
        }
      };
      script.onerror = function () {
        failed(script);
      };
      document.head.appendChild(script);
    }

    button.addEventListener('click', function () {
      open(activeImage());
    });

    gallery.addEventListener(
      'touchstart',
      function (event) {
        lastTouch = performance.now();

        if (
          !mobile.matches ||
          event.touches.length !== 1 ||
          !picture(event.target)
        ) {
          resetGesture();
          return;
        }

        var point = event.touches[0];

        touch = {
          id: point.identifier,
          x: point.clientX,
          y: point.clientY,
          time: performance.now(),
          image: picture(event.target)
        };
      },
      { capture: true, passive: true }
    );

    gallery.addEventListener(
      'touchmove',
      function (event) {
        if (!touch) {
          return;
        }

        var point = event.touches[0];

        if (
          event.touches.length !== 1 ||
          point.identifier !== touch.id ||
          Math.hypot(
            point.clientX - touch.x,
            point.clientY - touch.y
          ) > 12
        ) {
          resetGesture();
        }
      },
      { capture: true, passive: true }
    );

    gallery.addEventListener(
      'touchend',
      function (event) {
        if (!touch) {
          return;
        }

        var currentTouch = touch;
        var point = event.changedTouches[0];
        var now = performance.now();

        touch = null;

        if (
          event.touches.length ||
          !point ||
          point.identifier !== currentTouch.id ||
          now - currentTouch.time > 300 ||
          Math.hypot(
            point.clientX - currentTouch.x,
            point.clientY - currentTouch.y
          ) > 12
        ) {
          last = null;
          return;
        }

        var key = imageKey(currentTouch.image);

        if (
          last &&
          last.key === key &&
          now - last.time < 360 &&
          Math.hypot(
            point.clientX - last.x,
            point.clientY - last.y
          ) < 30
        ) {
          if (event.cancelable) {
            event.preventDefault();
          }

          open(currentTouch.image);
        } else {
          last = {
            key: key,
            time: now,
            x: point.clientX,
            y: point.clientY
          };
        }
      },
      { capture: true, passive: false }
    );

    gallery.addEventListener(
      'touchcancel',
      resetGesture,
      { passive: true }
    );

    ['contextmenu', 'dragstart'].forEach(function (eventName) {
      gallery.addEventListener(
        eventName,
        function (event) {
          if (mobile.matches && picture(event.target)) {
            event.preventDefault();
          }
        },
        { capture: true }
      );
    });

    gallery.addEventListener('dblclick', function (event) {
      if (
        performance.now() - lastTouch > 700 &&
        mobile.matches &&
        picture(event.target)
      ) {
        event.preventDefault();
        open(event.target);
      }
    });

    window.addEventListener('blur', resetGesture);

    function modeChanged() {
      resetGesture();
      pending = null;

      if (
        !mobile.matches &&
        window.BbkMobileImageViewerV2
      ) {
        window.BbkMobileImageViewerV2.close();
      }
    }

    if (mobile.addEventListener) {
      mobile.addEventListener('change', modeChanged);
    } else {
      mobile.addListener(modeChanged);
    }
  }

  function initQuantityKeyboard() {
    document.addEventListener('keydown', function (event) {
      var control = event.target.closest('.bedz-qty-control[role="button"]');

      if (!control || (event.key !== 'Enter' && event.key !== ' ')) {
        return;
      }

      event.preventDefault();
      control.click();
    });
  }

  function closestAnchor(node) {
    while (node && node !== document) {
      if (node.tagName && node.tagName.toLowerCase() === 'a') {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function isInsideProductDescription(node) {
    while (node && node !== document) {
      if (node.classList && node.classList.contains('product-description')) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  function getQueryValue(query, key) {
    if (!query) {
      return '';
    }

    var parts = query.replace(/^\?/, '').split('&');
    var i;
    var pair;

    for (i = 0; i < parts.length; i += 1) {
      pair = parts[i].split('=');
      if (decodeURIComponent(pair[0] || '') === key) {
        return decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
      }
    }

    return '';
  }

  function getYouTubeVideoId(url) {
    if (!url) {
      return '';
    }

    var parser = document.createElement('a');
    parser.href = url;

    var host = (parser.hostname || '').toLowerCase().replace(/^www\./, '');
    var path = parser.pathname || '';
    var videoId = '';

    if (host === 'youtu.be') {
      videoId = path.split('/')[1] || '';
    } else if (
      host === 'youtube.com' ||
      host === 'm.youtube.com' ||
      host === 'music.youtube.com' ||
      host === 'youtube-nocookie.com'
    ) {
      if (path === '/watch') {
        videoId = getQueryValue(parser.search, 'v');
      } else if (path.indexOf('/embed/') === 0) {
        videoId = path.split('/')[2] || '';
      } else if (path.indexOf('/shorts/') === 0) {
        videoId = path.split('/')[2] || '';
      } else if (path.indexOf('/live/') === 0) {
        videoId = path.split('/')[2] || '';
      }
    }

    videoId = (videoId || '').split(/[?&#/]/)[0];

    if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) {
      return '';
    }

    return videoId;
  }

  function getLinkLabel(link) {
    var text = (link.textContent || link.innerText || '').replace(/\s+/g, ' ').trim();
    return text || 'Product Video';
  }

  function setupInlineImageZoom(image, stage, viewer) {
    var zoom = 1;
    var x = 0;
    var y = 0;
    var activePointer = null;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var panStartX = 0;
    var panStartY = 0;
    var dragged = false;
    var lastTapTime = 0;
    var lastTapX = 0;
    var lastTapY = 0;
    var lastTouchZoomTime = 0;

    image.draggable = false;
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.title = 'Double-click or double-tap to zoom; drag to move';

    function updateLabel() {
      image.setAttribute(
        'aria-label',
        (image.alt || 'Report image') + '. Double-click or double-tap to zoom. Drag to move when enlarged.'
      );
    }

    function render() {
      var limitX = Math.max(0, (image.offsetWidth * zoom - stage.clientWidth) / 2);
      var limitY = Math.max(0, (image.offsetHeight * zoom - stage.clientHeight) / 2);
      x = Math.max(-limitX, Math.min(limitX, x));
      y = Math.max(-limitY, Math.min(limitY, y));
      image.style.transform = zoom === 1 ? '' :
        'translate(' + x + 'px,' + y + 'px) scale(' + zoom + ')';
      viewer.classList.toggle('is-zoomed', zoom > 1);
      image.setAttribute('aria-pressed', zoom > 1 ? 'true' : 'false');
    }

    function reset() {
      zoom = 1;
      x = 0;
      y = 0;
      activePointer = null;
      lastTapTime = 0;
      viewer.classList.remove('is-panning');
      render();
    }

    function toggle(clientX, clientY) {
      if (zoom > 1) {
        reset();
        return;
      }
      var bounds = image.getBoundingClientRect();
      zoom = 3;
      x = (bounds.left + bounds.width / 2 - clientX) * zoom;
      y = (bounds.top + bounds.height / 2 - clientY) * zoom;
      render();
    }

    image.addEventListener('dblclick', function (event) {
      event.preventDefault();
      if (Date.now() - lastTouchZoomTime < 650) return;
      toggle(event.clientX, event.clientY);
    });

    image.addEventListener('pointerdown', function (event) {
      if (zoom === 1 || activePointer !== null ||
          (event.pointerType === 'mouse' && event.button !== 0)) return;
      activePointer = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      panStartX = x;
      panStartY = y;
      dragged = false;
      image.setPointerCapture(event.pointerId);
    });

    image.addEventListener('pointermove', function (event) {
      if (activePointer !== event.pointerId) return;
      var dx = event.clientX - pointerStartX;
      var dy = event.clientY - pointerStartY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) {
        dragged = true;
        viewer.classList.add('is-panning');
      }
      if (!dragged) return;
      x = panStartX + dx;
      y = panStartY + dy;
      render();
    });

    image.addEventListener('pointerup', function (event) {
      var moved = activePointer === event.pointerId && dragged;
      if (activePointer === event.pointerId) {
        activePointer = null;
        viewer.classList.remove('is-panning');
        if (image.hasPointerCapture(event.pointerId)) {
          image.releasePointerCapture(event.pointerId);
        }
      }
      if (event.pointerType !== 'touch') return;
      if (moved) {
        lastTapTime = 0;
        return;
      }
      var now = Date.now();
      if (now - lastTapTime < 360 &&
          Math.abs(event.clientX - lastTapX) < 32 &&
          Math.abs(event.clientY - lastTapY) < 32) {
        if (event.cancelable) event.preventDefault();
        lastTapTime = 0;
        lastTouchZoomTime = now;
        toggle(event.clientX, event.clientY);
      } else {
        lastTapTime = now;
        lastTapX = event.clientX;
        lastTapY = event.clientY;
      }
    });

    image.addEventListener('pointercancel', function (event) {
      if (activePointer === event.pointerId) {
        activePointer = null;
        viewer.classList.remove('is-panning');
      }
      lastTapTime = 0;
    });

    image.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      var bounds = image.getBoundingClientRect();
      toggle(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2);
    });

    image.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    window.addEventListener('resize', function () {
      if (zoom > 1) render();
    });

    updateLabel();
    return { reset: reset, updateLabel: updateLabel };
  }

  function initDimensionsViewer() {
    var viewer = document.querySelector('[data-bedz-dimensions-viewer]');
    var triggers = Array.prototype.slice.call(
      document.querySelectorAll('[data-bedz-dimensions-trigger]')
    );

    if (!viewer || !triggers.length) return;

    var image = viewer.querySelector('[data-bedz-dimensions-image]');
    var closeButton = viewer.querySelector('[data-bedz-dimensions-close]');
    var fullImageLink = viewer.querySelector('.bedz-resource-image-viewer__foot a');
    var activeTrigger = null;

    if (!image || !closeButton) return;

    var imageZoom = setupInlineImageZoom(
      image,
      viewer.querySelector('.bedz-resource-image-viewer__stage'),
      viewer
    );

    function openViewer(event) {
      var trigger = event.currentTarget;
      var imageUrl = trigger.getAttribute('data-bedz-dimensions-src');
      if (!imageUrl) return;

      imageZoom.reset();
      activeTrigger = trigger;
      triggers.forEach(function (item) {
        item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false');
      });
      image.src = imageUrl;
      viewer.hidden = false;

      window.requestAnimationFrame(function () {
        viewer.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    function closeViewer(restoreFocus) {
      if (viewer.hidden) return;
      imageZoom.reset();
      viewer.hidden = true;
      image.removeAttribute('src');
      triggers.forEach(function (item) {
        item.setAttribute('aria-expanded', 'false');
      });
      if (restoreFocus && activeTrigger && activeTrigger.isConnected) {
        activeTrigger.focus({ preventScroll: true });
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', openViewer);
    });
    closeButton.addEventListener('click', function () {
      closeViewer(true);
    });
    document.addEventListener('click', function (event) {
      if (viewer.hidden) return;
      var target = event.target;
      if (image.contains(target) ||
          (fullImageLink && fullImageLink.contains(target)) ||
          (target.closest && target.closest('[data-bedz-dimensions-trigger]'))) {
        return;
      }
      closeViewer(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !viewer.hidden) {
        closeViewer(true);
      }
    });
  }

  function initYouTubeModal() {
    var modal = document.getElementById('BedzYoutubeModal');
    if (!modal) {
      return;
    }

    var player = modal.querySelector('[data-bedz-youtube-player]');
    var title = document.getElementById('BedzYoutubeModalTitle');
    var closeControls = modal.querySelectorAll('[data-bedz-youtube-close]');
    var activeTrigger = null;
    var i;

    function closeModal() {
      if (!modal.classList.contains('is-open')) {
        return;
      }

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bedz-youtube-modal-open');
      document.body.classList.remove('bedz-youtube-modal-open');

      while (player.firstChild) {
        player.removeChild(player.firstChild);
      }

      player.classList.remove('bedz-youtube-modal__player--portrait');
      modal.classList.remove('bedz-youtube-modal--portrait');

      if (activeTrigger && typeof activeTrigger.focus === 'function') {
        activeTrigger.focus();
      }
      activeTrigger = null;
    }

    function openModal(link, videoId, layout) {
      var iframe = document.createElement('iframe');
      var embedUrl = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) +
        '?autoplay=1&playsinline=1&rel=0';
      var isPortrait = layout === 'portrait';

      activeTrigger = link;
      title.textContent = getLinkLabel(link);

      if (isPortrait) {
        player.classList.add('bedz-youtube-modal__player--portrait');
        modal.classList.add('bedz-youtube-modal--portrait');
      } else {
        player.classList.remove('bedz-youtube-modal__player--portrait');
        modal.classList.remove('bedz-youtube-modal--portrait');
      }

      iframe.setAttribute('src', embedUrl);
      iframe.setAttribute('title', getLinkLabel(link));
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      while (player.firstChild) {
        player.removeChild(player.firstChild);
      }
      player.appendChild(iframe);

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bedz-youtube-modal-open');
      document.body.classList.add('bedz-youtube-modal-open');

      var closeButton = modal.querySelector('.bedz-youtube-modal__close');
      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var link = closestAnchor(event.target);
      if (!link) {
        return;
      }

      var isExplicitVideoLink = link.getAttribute('data-bedz-youtube') === 'true' ||
        (link.classList && link.classList.contains('bedz-youtube-link'));
      var isDescriptionLink = isInsideProductDescription(link);

      if (!isExplicitVideoLink && !isDescriptionLink) {
        return;
      }

      var videoUrl = link.getAttribute('href');
      var videoLayout = link.getAttribute('data-bedz-youtube-layout') || '';
      var videoId = getYouTubeVideoId(videoUrl);
      if (!videoId) {
        return;
      }

      event.preventDefault();
      openModal(link, videoId, videoLayout);
    });

    for (i = 0; i < closeControls.length; i += 1) {
      closeControls[i].addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (event) {
      var key = event.key || event.keyCode;
      if ((key === 'Escape' || key === 'Esc' || key === 27) && modal.classList.contains('is-open')) {
        event.preventDefault();
        closeModal();
      }
    });
  }

  function initFeraReviews() {
    var bedzFeraTargetRoot = document.querySelector(
      '.bedz-fera-trigger [data-fera-widget="product_detail_rating"][data-product-id]'
    );

    if (!bedzFeraTargetRoot) {
      return;
    }

    var bedzFeraProductId = bedzFeraTargetRoot.getAttribute('data-product-id');

    if (!bedzFeraProductId) {
      return;
    }
    var bedzFeraApiKey =
      'pk_bfe030e87cfe58cab61d891acf252f3b8ad6140806c38be1c65ce0427b53af17';
    var bedzFeraStoreDomain = 'bunkbedking.myshopify.com';
    var bedzFeraBaseCdnUrl = 'https://cdn.fera.ai/js/v3/';

    var bedzFeraLoadRequested = false;
    var bedzFeraOpenRequested = false;
    var bedzFeraTargetWatchActive = false;

    function getBedzReviewButton(node) {
      while (node && node !== document) {
        if (
          node.getAttribute &&
          node.getAttribute('data-bedz-review-summary') === 'true'
        ) {
          return node;
        }

        node = node.parentNode;
      }

      return null;
    }

    function getBedzFeraTarget() {
      return document.querySelector(
        '.bedz-fera-trigger [data-fera-widget="product_detail_rating"] .fera-averageRating--clickable'
      );
    }

    function openFeraReviewsWhenReady() {
      var started = Date.now();

      if (bedzFeraTargetWatchActive) {
        return;
      }

      bedzFeraTargetWatchActive = true;

      function checkForFeraTarget() {
        var target = getBedzFeraTarget();

        if (target) {
          bedzFeraTargetWatchActive = false;
          bedzFeraOpenRequested = false;
          target.click();
          return;
        }

        if (Date.now() - started < 10000) {
          window.setTimeout(checkForFeraTarget, 100);
          return;
        }

        bedzFeraTargetWatchActive = false;
      }

      checkForFeraTarget();
    }

    function configureBedzFera() {
      if (window.fera && window.fera.version) {
        return;
      }

      if (!window.fera || typeof window.fera.push !== 'function') {
        window.fera = [];
      }

      if (window.bedzFeraConfigured) {
        return;
      }

      window.bedzFeraConfigured = true;

      window.fera.push({
        action: 'setProductId',
        product_id: bedzFeraProductId
      });

      window.fera.push('configure', {
        api_key: bedzFeraApiKey,
        store_domain: bedzFeraStoreDomain
      });
    }

    function ensureBedzFeraCss() {
      var existingCss =
        document.getElementById('fera_css') ||
        document.querySelector(
          '[data-app-id][href*="fera.css"], link[href*="cdn.fera.ai/js/v3/fera.css"]'
        );

      if (existingCss) {
        return;
      }

      var css = document.createElement('link');

      css.href = bedzFeraBaseCdnUrl + 'fera.css';
      css.id = 'fera_css';
      css.rel = 'stylesheet';
      css.media = 'all';

      document.head.prepend(css);
    }

    function ensureBedzFeraJs() {
      if (window.fera && window.fera.version) {
        return;
      }

      var existingScript =
        document.getElementById('fera_js') ||
        document.querySelector(
          '[data-app-id][src*="fera.js"], script[src*="cdn.fera.ai/js/v3/fera.js"]'
        );

      if (existingScript) {
        return;
      }

      var script = document.createElement('script');

      script.src = bedzFeraBaseCdnUrl + 'fera.js';
      script.id = 'fera_js';
      script.async = true;

      script.addEventListener('error', function () {
        bedzFeraLoadRequested = false;

        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });

      document.body.append(script);
    }

    function loadBedzFera(openReviews) {
      if (openReviews) {
        bedzFeraOpenRequested = true;
      }

      if (window.fera && window.fera.version) {
        if (bedzFeraOpenRequested) {
          openFeraReviewsWhenReady();
        }

        return;
      }

      if (!bedzFeraLoadRequested) {
        bedzFeraLoadRequested = true;

        configureBedzFera();
        ensureBedzFeraCss();
        ensureBedzFeraJs();
      }

      if (bedzFeraOpenRequested) {
        openFeraReviewsWhenReady();
      }
    }

    function loadBedzFeraAfterScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0;

      if (
        bedzFeraLoadRequested ||
        (window.fera && window.fera.version)
      ) {
        window.removeEventListener(
          'scroll',
          loadBedzFeraAfterScroll
        );
        return;
      }

      if (scrollTop < 150) {
        return;
      }

      window.removeEventListener(
        'scroll',
        loadBedzFeraAfterScroll
      );

      loadBedzFera(false);
    }

    document.addEventListener('click', function (event) {
      var button = getBedzReviewButton(event.target);

      if (!button) {
        return;
      }

      event.preventDefault();
      loadBedzFera(true);
    });

    window.addEventListener(
      'scroll',
      loadBedzFeraAfterScroll,
      { passive: true }
    );
  }

  function init() {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    initGallery();
    initDesktopImageOverlay();
    initDesktopThumbnails();
    initVariantSelectors();
    initQuantityControls();
    initQuantityKeyboard();
    initMattressLinks();
    initMattressAddToCart();
    initTabs();
    initDimensionsViewer();
    initYouTubeModal();
    initFeraReviews();
    initMobileImageViewer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
